import React, { useState } from 'react'

export default function Shop() {

    return (
        <div className='PageContent'>
            <span>Shop</span>
        </div>
    )
}